import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.discounts = ReducerFuncs }

export {
  Routes,
  Reducers
}
